__turbopack_context__.v({
  "description": "Loan-module-scss-module__l0ileG__description",
  "fade-in": "Loan-module-scss-module__l0ileG__fade-in",
  "form": "Loan-module-scss-module__l0ileG__form",
  "no-transform": "Loan-module-scss-module__l0ileG__no-transform",
  "rotate": "Loan-module-scss-module__l0ileG__rotate",
  "skeletonCenterButton": "Loan-module-scss-module__l0ileG__skeletonCenterButton",
  "skeletonGrid": "Loan-module-scss-module__l0ileG__skeletonGrid",
  "skeletonInput": "Loan-module-scss-module__l0ileG__skeletonInput",
});
